import { Badge } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-community';

import { formatNumber } from '~/utils/common';
import { formatDate } from '~/utils/date';

import { DATE_FORMAT } from '~/constants';
import {
  RECEIVE_STATUS_DETAIL_STATUS,
  RECEIVE_STATUS_DETAIL_STATUS_BADGE_COLOR,
  type TypeReceiveStatusDetailStatus,
} from '~/constants/receive';

import type { Type3PLReceiveStatusDetail } from '~/types/receive.types';

type Type3PLReceiveStatusDetailItem = Type3PLReceiveStatusDetail['items'][number];

/**
 * [입고관리 > 입고현황 (3PL)] 입고 현황 상세 모달 > 입고 처리 상세 테이블
 */
const getReceiveStatusDetail3PLColumnDefs = () => {
  const columnDefs: ColDef<Type3PLReceiveStatusDetailItem>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'status',
      headerName: '작업상태',
      width: 92,
      cellRenderer: Badge,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<Type3PLReceiveStatusDetailItem, Type3PLReceiveStatusDetailItem['status']>) => ({
        variant: 'light',
        status: true,
        color: RECEIVE_STATUS_DETAIL_STATUS_BADGE_COLOR[value as TypeReceiveStatusDetailStatus],
        children: RECEIVE_STATUS_DETAIL_STATUS[value as TypeReceiveStatusDetailStatus],
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 140,
    },
    {
      field: 'goodsName',
      headerName: '상품명',
      minWidth: 240,
      flex: 1,
    },
    {
      field: 'requestedQty',
      headerName: '요청수량',
      width: 80,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<Type3PLReceiveStatusDetailItem, Type3PLReceiveStatusDetailItem['requestedQty']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'receivedQty',
      headerName: '입고완료수량',
      width: 98,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<Type3PLReceiveStatusDetailItem, Type3PLReceiveStatusDetailItem['receivedQty']>) =>
        value ? formatNumber(value) : '-',
    },
    {
      field: 'receivedDate',
      headerName: '입고확정일시',
      width: 178,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<Type3PLReceiveStatusDetailItem, Type3PLReceiveStatusDetailItem['receivedDate']>) =>
        formatDate(value, DATE_FORMAT.DATE_TIME) ?? '-',
    },
  ];

  return { columnDefs };
};

export default getReceiveStatusDetail3PLColumnDefs;
